// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RenderControls_container__05kiv {
  margin: 1em;
  position: absolute;
  bottom: 0;
  right: 0;
  background: #ededed;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ThreeJS/RenderControls/RenderControls.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".container {\n  margin: 1em;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  background: #ededed;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RenderControls_container__05kiv`
};
export default ___CSS_LOADER_EXPORT___;
